import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';

type Props = { rows: any[]; selectedId?: any; loading?: boolean; onSelect: (row: any) => void };

class PpmGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'shc', headerName: 'PPM Code', width: 160 },
    { field: 'nam', headerName: 'PPM Name', flex: 1, minWidth: 260 },
    { field: 'fyr', headerName: 'Year', width: 90 },
    { field: 'pst', headerName: 'Status', width: 130, renderCell: (p) => <Chip size="small" label={p.value || '-'} /> },
    { field: 'bvc', headerName: 'Budget Version', width: 160 },
    { field: 'lct', headerName: 'Lines', width: 90, type: 'number' },
    { field: 'tam', headerName: 'Total', width: 150, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Procurement Plans"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={330}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(row: any) => row.rid || row.id}
        onRowClick={(p: any) => this.props.onSelect(p.row)}
        getRowClassName={(p: any) => String(p.row.rid || p.row.id) === String(this.props.selectedId) ? 'selected-ppm-row' : ''}
        sx={{ '& .selected-ppm-row': { bgcolor: '#e3f2fd' }, '& .MuiDataGrid-row': { cursor: 'pointer' } }}
      />
    );
  }
}
export default PpmGrid;
